import Badge from 'common/components/Badge'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import { selectElement } from 'features/unifiedFlow/store/unifiedFlowSlice'

import AddTemplateButton from '../../components/AddTemplateButton'
import ElementCard from '../../components/ElementCard'
import { useContent } from '../../hooks'

export const BRIEF_ELEMENT_ID = 'brief'

const ElementsList = () => {
  const dispatch = useAppDispatch()

  const { content } = useContent()
  const elements = content?.elements

  const selectedElementId = useAppSelector(
    (state) => state.unifiedFlow.selectedElementId
  )
  const areElementsDisabled = useAppSelector(
    (state) => state.unifiedFlow.areElementsDisabled
  )

  const isRemoveOptionShown = content?.elements && content.elements.length > 1

  return (
    <>
      <ElementCard
        title="Brief"
        className="mb-4"
        icon="startFlag"
        isSelected={selectedElementId === BRIEF_ELEMENT_ID}
        onClick={() => dispatch(selectElement({ elementId: BRIEF_ELEMENT_ID }))}
      />
      {elements &&
        elements.map((element, index) => {
          const { element_id, name, display_name, icon, status } = element
          const isElementDisabled = areElementsDisabled || status === 'disabled'
          const isAwaitingBrief =
            element.user_input_form_compatible === false &&
            element.settings_customisation === false

          // TODO: Remove data mocking when we connect with the backend
          const isOptimizable =
            index < 3 || element.experiment_type?.optimization === 'enabled'
          const isPersonalizable =
            index < 5 || element.experiment_type?.personalization === 'enabled'

          return (
            <ElementCard
              className="mb-4"
              key={element_id}
              element={element}
              title={display_name || name}
              icon={icon}
              isDisabled={isElementDisabled}
              isRemoveOptionShown={isRemoveOptionShown}
              isSelected={
                element_id === selectedElementId && !isElementDisabled
              }
              isConfigurable={true}
              content={
                isAwaitingBrief || isOptimizable || isPersonalizable ? (
                  <div className="flex flex-wrap gap-1">
                    {isAwaitingBrief && (
                      <Badge
                        text="Awaiting brief"
                        variant="warning"
                        size="small"
                      />
                    )}
                    {isOptimizable && (
                      <Badge text="Optimize" variant="optimize" size="small" />
                    )}
                    {isPersonalizable && (
                      <Badge
                        text="Personalize"
                        variant="personalize"
                        size="small"
                      />
                    )}
                  </div>
                ) : null
              }
              onClick={() =>
                !isElementDisabled &&
                dispatch(selectElement({ elementId: element_id }))
              }
            />
          )
        })}
      <AddTemplateButton isDisabled={areElementsDisabled} />
    </>
  )
}

export default ElementsList
